import script from "./PrivacyView.vue?vue&type=script&setup=true&lang=js"
export * from "./PrivacyView.vue?vue&type=script&setup=true&lang=js"

import "./PrivacyView.vue?vue&type=style&index=0&id=8e353922&lang=css"

const __exports__ = script;

export default __exports__